import React from "react";
import { Card, Avatar, Input, Button } from "antd";
import {
  LeftOutlined,
  DownOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import AuthService from "../../../session/AuthService";
import { sendMoney } from "../../../api/UserAPI";
import { useGlobalUI } from "../../../context/GlobalUIProvider";

const TransferForm = ({
  formData,
  handleChange,
  setActiveTab,
  userDetails,
  walletDetails,
  settingDetails,
  customerType,
}) => {
  const { showLoader, hideLoader, message } = useGlobalUI();

  console.log("formData", formData);
  const calculateTierFee = (flatFee, percentage, amount) => {
    if (flatFee != null && flatFee > 0) return flatFee;
    if (percentage != null && percentage > 0)
      return (amount * percentage) / 100;
    return 0;
  };

  const calculateTransferFee = (config, amountToSend) => {
    console.log("config", config);
    if (!config) return 0;
    if (config.flatConfig) return config.transferFee || 0;
    if (config.percentageConfig) {
      if (
        amountToSend >= (config.percentageMinimumFee || 0) &&
        amountToSend <= (config.percentageMaximumFee || Infinity)
      ) {
        return (amountToSend * (config.percentageStandardRate || 0)) / 100;
      }
      return (amountToSend * 10) / 100;
    }
    if (config.tierConfigEnabled) {
      if (
        amountToSend >= config.tier1MinAmount &&
        amountToSend <= config.tier1MaxAmount
      )
        return calculateTierFee(
          config.tier1FlatFee,
          config.tier1Percentage,
          amountToSend
        );
      if (
        amountToSend >= config.tier2MinAmount &&
        amountToSend <= config.tier2MaxAmount
      )
        return calculateTierFee(
          config.tier2FlatFee,
          config.tier2Percentage,
          amountToSend
        );
      if (amountToSend >= config.tier3MinAmount)
        return calculateTierFee(
          config.tier3FlatFee,
          config.tier3Percentage,
          amountToSend
        );
    }
    return 0;
  };

  const handleSendMoney = (mobile, amount) => {
    const availableBalance = parseFloat(walletDetails.totalBalance);
    const enteredAmount = parseFloat(amount);

    if (enteredAmount > availableBalance) {
      message.error("Insufficient Balance");
      return;
    }

    showLoader();
    sendMoney({
      id: AuthService.getAuthId(),
      mobileNo: mobile,
      amountSend: enteredAmount,
    }).then((res) => {
      hideLoader();
      if (res.data.status === 1) {
        message.success("Transaction Successful.");
        setActiveTab("sendMoneySuccess");
      } else {
        message.error(res.data.message);
      }
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#f9f9f9",
      }}
    >
      <Card
        style={{
          maxWidth: 430,
          borderRadius: 18,
          flex: 1,
        }}
      >
        <LeftOutlined
          style={{ fontSize: 18, cursor: "pointer", marginRight: 12 }}
          onClick={() => setActiveTab("home")}
        />

        {/* Header */}
        <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 18 }}>
          Money from
        </div>

        {/* Wallet Info */}
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 14 }}
        >
          <Avatar size={40}>{userDetails.name?.[0]}</Avatar>
          <span style={{ marginLeft: 8, fontWeight: 500 }}>
            Personal wallet
          </span>
          <span style={{ marginLeft: "auto", fontWeight: 500 }}>
            {userDetails.nationality === "Indian" ? "₹" : "$"}{" "}
            {parseFloat(walletDetails.totalBalance).toFixed(2)}
          </span>
        </div>
        <hr />

        {/* Money To */}
        <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 5 }}>
          Money to
        </div>

        <span style={{ flex: 1, color: formData.payee ? "#222" : "#bbb" }}>
          {formData.payee ? formData.payee.mobileNo : "-"}
        </span>

        <br />
        <br />

        <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 5 }}>
          Account Number
        </div>

        <span style={{ flex: 1, color: formData.payee ? "#222" : "#bbb" }}>
          {formData.payee ? formData.payee.accountNumber : "-"}
        </span>

        <br />
      </Card>

      {/* Fixed Bottom Section */}
      <div
        style={{
          position: "fixed",
          bottom: 60,
          left: 0,
          right: 0,
          background: "#fff",
          padding: "16px",
          borderTop: "1px solid #eee",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
          }}
        >
          {/* Amount Input */}
          <Input
            type="number"
            placeholder="Enter amount"
            bordered={false}
            value={formData.amount}
            onChange={(e) => handleChange("amount", e.target.value)}
            style={{
              flex: 1,
              fontSize: 20,
              fontWeight: 600,
              padding: "10px 14px",
              borderRadius: 12,
              background: "#f5f5f5",
            }}
          />

          {/* Send Button */}
          <Button
            shape="circle"
            type="primary"
            size="large"
            icon={<ArrowRightOutlined />}
            onClick={() =>
              handleSendMoney(formData.payee.mobileNo, Number(formData.amount))
            } // Replace with your API call
            style={{ width: 56, height: 56, fontSize: 20 }}
          />
        </div>

        {/* Fee text */}
        <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 8 }}>
          {formData.amount
            ? "Platform Fees : " +
              calculateTransferFee(
                settingDetails.feeConfig.find(
                  (e) => e.customerType === customerType
                ),
                Number(formData.amount)
              )
            : "No Fee"}
        </div>
      </div>
    </div>
  );
};

export default TransferForm;
